import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Svg } from "./Svg";
function isNumber(value) {
    return !isNaN(value) && !isNaN(parseFloat(value));
}
/**
 *
 * @param {string} url
 * @param {string} text
 * @param {string} iconName
 * @param {string|number} number
 * @param {function} onClick
 * @param hideNumber
 * @returns {JSX.Element}
 * @constructor
 */
const HeaderIconButton = ({ url, text, iconName, onClick, number, hideNumber }) => {
    let showNumber = isNumber(number) && !hideNumber;
    return (_jsx(_Fragment, { children: _jsx("div", { className: "header__icon-button", children: _jsxs("a", { href: url, className: "header__icon-button_link", rel: "nofollow", title: text, onClick: onClick, children: [_jsxs("i", { className: "header__icon-button_icon", children: [_jsx(Svg, { icon: iconName }), showNumber && _jsx("i", { className: "header__icon-button_number", children: number })] }), _jsx("span", { className: "header__icon-button_title hide-on-large", children: text })] }) }) }));
};
export default HeaderIconButton;
